import IValidationRule from "./ValidationRule";

export default class ValidationRuleNumber implements IValidationRule {
  private _message: string | undefined;

  public get message(): string | undefined {
    return this._message;
  }

  public check(value: any): boolean {
    this._message = undefined;

    if (value == null || (value + "").length === 0) {
      return true;
    }

    if (isNaN(value)) {
      this._message = `숫자 형식이 올바르지 않습니다.`;

      return false;
    }

    return true;
  }
}
